<template lang="pug">
  ._layout
    OfflineCompanion
    ProfileHeader
    ._layout-content
      GlobalWrapper
        nuxt
    TheBottomTabBar
</template>

<script>
import ProfileHeader from '~/components/profile/ProfileHeader'
import TheBottomTabBar from '~/components/TheBottomTabBar'
import OfflineCompanion from '~/components/OfflineCompanion'
import GlobalWrapper from '../components/GlobalWrapper'

export default {
  middleware: ['Authenticated', 'IsOffline', 'IsLocked'],
  components: {
    ProfileHeader,
    TheBottomTabBar,
    OfflineCompanion,
    GlobalWrapper,
  },
  computed: {
    isDev() {
      return this.$root.context.isDev
    },
  },
  methods: {
    resetCoaching() {
      this.$store.commit('coaching/UPDATE_ROOT', {
        current: null,
        offlineSync: {},
        lastCoaching: null,
      })
      this.$store.commit('coaching/UPDATE_CURRENT', null)
      this.$router.push('/coaching')
    },
  },
}
</script>

<style lang="sass" scoped>
body
  --bgColor: #EBEBEB
  --iconColor: #FFFFFF
  --iconActiveColor: #30BAE3
  --primaryColor: #232378
  --textColor: #767676
  --textHighlightColor: #232323
  --backgroundSteak: #ffaaa5
  --greenColor: #00e686
  --darkBlueColor: #1A4982
  background-color: var(--bgColor)
  color: var(--textColor)
  font:
    family: 'Montserrat', sans-serif
    size: 16px
._layout
  display: flex
  flex-direction: column
  min-height: 100vh
  &-content
    position: relative
    flex: 1
.resetCoaching
  --size: 32px
  position: fixed
  top: 16px
  left: calc(50vw - var(--size)/2)
  display: flex
  align-items: center
  justify-content: center
  color: white
  background: red
  border-radius: 50%
  width: var(--size)
  height: var(--size)
</style>
